import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_DESCRIPTION, DEFAULT_TITLE, SHARE_IMAGE, headTags, jsonForScript, siteJsonLd } from '@/content/seo/site';

/**
 * Site-wide defaults under every page: the default title and description, the
 * share image, and the Organization and WebSite structured data. A page's own
 * PageSeo overrides the title and any tag with the same name or property; the
 * structured data here is never repeated by a page.
 */
const DEFAULTS = { title: DEFAULT_TITLE, description: DEFAULT_DESCRIPTION, image: SHARE_IMAGE, jsonLd: siteJsonLd() };

export default function SeoDefaults() {
  return (
    <Helmet>
      <title>{DEFAULTS.title}</title>
      {headTags(DEFAULTS).map(({ tag: Tag, attrs, json }, i) => (
        json !== undefined
          ? <script key={i} {...attrs}>{jsonForScript(json)}</script>
          : <Tag key={i} {...attrs} />
      ))}
    </Helmet>
  );
}
